import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import {
    Button,
    Grid
} from '@material-ui/core';
import axios from 'axios';
import Common from '../../Common';

const styles = () => ({
    displayFlex: {
        display: 'flex'
    },
    verticalSpace: {
        margin: '0px 20px 0px 50px',
    },
    searchButtonSpace: {
        margin: '0px 0px 0px 600px',
    }
});

const SearchButton = withCookies((props) => {
    const {
        classes,
        setData,
        chatId,
        keyword,
        address,
        includeNotPaticipateFlg,
        includeUserInChat,
        setAllUpdate,
        cookies,
        setIsLoading
    } = props;
    const chatNameObj = cookies.get('COMMON_NAME_OBJ');
    const kubunName = chatNameObj !== undefined ? chatNameObj.KUBUN_NAME : 'チャットカテゴリ';

    const setUserDatas = () => {
        if(chatId === ''){
            window.alert(`${kubunName}を選択してください。`);
            return;
        }
        //setAllUpdate(false);
        setIsLoading(true);
        axios.post(
            `${Common.apiServerUrl()}/api/search`,
            {
                chatId,
                keyword,
                address,
                includeNotPaticipateFlg,
                includeUserInChat
            },
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + cookies.get('access_token'),
                    'x-suppportcenter-token': cookies.get('token'),
                    'x-jichitai-jichitaiid': cookies.get('x-jichitai-jichitaiid'),
                    'x-jichitai-token': cookies.get('x-jichitai-token'),
                },
                data: {},
            }
        )
        .then(Common.handleErrors)
        .then((res) => {
            if (res.success) {
                if(res.result.length === 0) window.alert('絞り込み条件に合致する結果が⾒つかりませんでした。');
                setData(res.result);
            } else {
                window.alert(`code : [${res.type}]\nmessage : ${res.message}`);
            }
        })
        .catch((err) => {
            console.error('ChatUserSearchButton.js setUserDatas:get err:' + err.message);
        })
        .finally(() => {
            setIsLoading(false);
        });
    };

    return (
        <React.Fragment>
            <Grid>
                <div>
                    <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                        <Button color="primary" size="large" className={classes.searchButtonSpace} variant="contained" onClick={() => setUserDatas()}>検索</Button>
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
});

SearchButton.propTypes = {
    chatId: PropTypes.string.isRequired,
    setData: PropTypes.func.isRequired,
    keyword: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    includeNotPaticipateFlg: PropTypes.bool.isRequired,
    includeUserInChat: PropTypes.bool.isRequired,
    cookies: PropTypes.object.isRequired,
};

export default withStyles(styles)(SearchButton);